<div [class]="classes()" [attr.role]="role()">
  <span [class]="iconClass()">
    @switch (variant()) {
      @case ('success') {
        <svg class="size-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M5 12.5l4.5 4.5L19 7.5" />
        </svg>
      }
      @case ('error') {
        <svg class="size-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="9" />
          <path d="M12 7.5v5.5M12 16.4v.1" />
        </svg>
      }
      @case ('warning') {
        <svg class="size-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M12 3.5l9.5 16.5h-19L12 3.5z" />
          <path d="M12 10v4.5M12 17.4v.1" />
        </svg>
      }
      @default {
        <svg class="size-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <circle cx="12" cy="12" r="9" />
          <path d="M12 11v5.5M12 7.6v.1" />
        </svg>
      }
    }
  </span>

  <p class="min-w-0 flex-1 pt-px text-ui text-primary">{{ text() }}</p>

  <button
    type="button"
    (click)="dismissed.emit()"
    class="touch-hit relative -mt-px -mr-0.5 flex size-6 shrink-0 items-center justify-center rounded-sm text-secondary transition-nike hover:bg-grey-100 hover:text-primary focus-visible:outline-none focus-visible:shadow-focus"
    aria-label="Dismiss">
    <svg class="size-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18 6L6 18M6 6l12 12" />
    </svg>
  </button>
</div>
